/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)


// axios
// import axios from './axios.js'
// import axios from './api/index.js'
// Vue.prototype.$http = axios

// Filters
import './filters/filters.js'


// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')

// Cookie
import VueCookie from 'vue-cookie'
Vue.use(VueCookie)

import commonUtils from './commonUtils.js'
Vue.use(commonUtils)

// VeeValidate
import VeeValidate, { Validator } from 'vee-validate'
import KoreanValidate from 'vee-validate/dist/locale/ko'

import { AuthAttributes } from '@/constants/auth'
import {  InstituteAttributes } from '@/constants/institute'
import {  MemberAttributes } from '@/constants/member'
import {  StudentAttributes } from '@/constants/student'
import {  TeacherAttributes } from '@/constants/teacher'
import {  BookAttributes } from '@/constants/book'
const attributeDictionary = {
  ko: {
    attributes: Object.assign(
      {},
      AuthAttributes, 
      InstituteAttributes,
      MemberAttributes,
      StudentAttributes,
      TeacherAttributes,
      BookAttributes
    )
  }
}

Validator.localize('ko', KoreanValidate)
Vue.use(VeeValidate, {locale: KoreanValidate, dictionary:attributeDictionary })


import vueMoment from 'vue-moment'
Vue.use(vueMoment)

import 'vue-good-table/dist/vue-good-table.css'

// Vue select css
// Note: In latest version you have to add it separately
import 'vue-select/dist/vue-select.css'

// import svgSpriteLoader from '@/components/editor/helpers/svg-sprite-loader.js'
// const __svg__ = { path: '@/assets/images/tiptap/icons/*.svg', name: 'assets/images/tiptap/[hash].sprite.svg' }
// svgSpriteLoader(__svg__.filename)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
